<template>
  <div class="inner">
    <template v-if="isUnsupportedDevice">
      <ScrollupSection />
      <div class="all-area">
        <HeaderSection />
        <section class="contact-area bg-gray ptb_100">
          <div class="container text-center">
            <p>Download the APP for mobile</p>
            <div class="download-options">
              <div class="download-option">
                <img class="download-qr" src="/assets/img/qr/app_store.jpg" alt="Apple App Store QR code">
                <a class="btn btn-bordered download-btn" :href="appStoreUrl" target="_blank" rel="noopener">Apple</a>
              </div>
              <div class="download-option">
                <img class="download-qr" src="/assets/img/qr/google_play.jpg" alt="Google Play QR code">
                <a class="btn btn-bordered download-btn" :href="playStoreUrl" target="_blank" rel="noopener">Google Play</a>
              </div>
            </div>
          </div>
        </section>
        <FooterSection />
      </div>
    </template>
    <template v-else>
      Redirecting...
    </template>
  </div>

</template>
<script>
import FooterSection from "@/components/Footer/Footer.vue";
import HeaderSection from "@/components/Header/HeaderOne.vue";
import ScrollupSection from "@/components/Scrollup/Scrollup.vue";

export default {
  name: 'AppDownload',
  components: {ScrollupSection, HeaderSection, FooterSection},
  data() {
    return {
      appStoreUrl: process.env.VUE_APP_IOS_DOWNLOAD_URL,
      playStoreUrl: process.env.VUE_APP_ANDROID_DOWNLOAD_URL,
      isUnsupportedDevice: false
    }
  },
  mounted() {
    const ua = navigator.userAgent || navigator.vendor || window.opera

    if (/iPhone|iPad|iPod/i.test(ua)) {
      window.location.href = process.env.VUE_APP_IOS_DOWNLOAD_URL
    } else if (/Android/i.test(ua)) {
      window.location.href = process.env.VUE_APP_ANDROID_DOWNLOAD_URL
    } else {
      this.isUnsupportedDevice = true
    }
  }
}
</script>
<style scoped>
.download-options {
  display: flex;
  justify-content: center;
  gap: 32px;
  flex-wrap: wrap;
  margin-top: 28px;
}

.download-option {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.download-qr {
  width: 180px;
  max-width: 100%;
  border-radius: 8px;
  margin-bottom: 18px;
}

.download-btn.btn-bordered {
  min-width: 150px;
  background: #000;
  border-color: #000;
  color: #fff;
}

.download-btn.btn-bordered::before,
.download-btn.btn-bordered::after {
  background: #000;
}

.download-btn.btn-bordered:hover,
.download-btn.btn-bordered:focus {
  background: #000;
  border-color: #000;
  color: #fff;
}

.download-btn.btn-bordered:hover::after,
.download-btn.btn-bordered:focus::after {
  opacity: 1;
}
</style>
